import type { IconProps } from '../types/IconProps.ts';
export const Hashtag: IconProps = {
    name: 'Hashtag',
    children: [
        `<path d="M4 9h16M4 15h16M7 21l3-18M14 21l3-18" />`,
    ]
};